"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Link from "./webflow_modules/Basic/components/Link";

export function MarketAmenityPagesFilterResultsButton({
  linkProps = {
    href: "#",
  },
}) {
  return (
    <Block className={"filter-results-button"} tag={"div"}>
      <Block className={"hide-mobile-landscape"} tag={"div"}>
        <Link button={false} className={"button-copy"} options={linkProps}>
          {"Filter Results"}
        </Link>
      </Block>
      <Block
        className={"show-mobile-landscape"}
        id={"w-node-_528b0b7a-b231-71d6-dcf8-ab572ea4aedd-2ea4aed9"}
        tag={"div"}
      >
        <Link
          block={"inline"}
          button={false}
          className={"button is-filter"}
          id={"w-node-_528b0b7a-b231-71d6-dcf8-ab572ea4aede-2ea4aed9"}
          options={linkProps}
        >
          <HtmlEmbed
            className={"icon-embed-xsmall-2"}
            content={
              '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--ic" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="currentColor" d="M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z"/></svg>'
            }
          />
        </Link>
      </Block>
    </Block>
  );
}
